<!--
================================================
Le composant pointeuse
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div class="pointeuse">

                <div class="appTitle">
                    <font-awesome-icon :icon="['fas', 'stopwatch']" />
                    {{$t('MaPointeuse')}}
                </div>

                <div class="appBloc blocPointeuse">

                    <div class="compLoader" v-if="!componentIsReady">
<!--                        <div class="loader"></div>-->
                        <spinner-loader-comp v-bind:loading-txt="$t('chargement')"></spinner-loader-comp>
                    </div>

                    <div class="blocPointeuseContent" v-else>

                        <div class="now">
                            <span class="date"> {{ dateNow }}</span>
                            <span class="time" v-bind:title="$t('fuseauHoraireActuel:x',{tz: userTimezone})" > {{ timeNow }}</span>
<!--                            <span class="userTz" v-bind:title="$t('fuseauHoraireActuel')"> {{ userTimezone }}</span>-->
                        </div>

                        <div  class="dailyTimer" id="dailyTimer" v-bind:class="{'running':isClockedIn}">
                            {{timerDisplayValue}}
                        </div>

                        <div class="clockInOutBtns">
                         <a v-if="isClockedIn" v-on:click="clockOut()" class="btnClockIn button is-medium is-fullwidth " id="btnClockOut" v-bind:class="{'is-loading':isSubmiting}">
                            <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="icon" />
                            {{$t('Sortir')}}</a>

                            <a v-else v-on:click="clockIn()" class="btnClockIn button is-medium is-fullwidth" id="btnClockIn" v-bind:class="{'is-loading':isSubmiting}">
                            <font-awesome-icon :icon="['fas', 'sign-in-alt']" class="icon" />

                            {{$t('Entrer')}}</a>
                        </div>

                    </div>
                </div>

    </div>
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import TimezoneMixin from "../mixins/TimezoneMixin.js"
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import TimeMixin from "../mixins/TimeMixin";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'PointeuseComp',
        components: {
            SpinnerLoaderComp,
        },
        mixins: [TimezoneMixin, SentryMixin, InterceptorMixin, GlobalErrorNotification, TimeMixin, TrackingMixin],

        data: function () {
            return {
                organizationSlug: this.$route.params.organization,

                now: null,
                componentIsReady : false, // indique quant on peut afficher le composant totalement hydraté
                tzDetected : this.detectTimezone(),
                isClockedIn: false, // si true signifie que l'utilisateur a un timerecord en cours (timeOut vaut null)
                isSubmiting: false, // indique si un pointage est en cours (pour afficher un loader dans les boutons .btnClockIn)
                // dailyTime:  null,
                timer: null,    // un objet easyTimer.js
                timerDisplayValue: null, // la valeur du timer
                timerStartValues: null, // les valeurs de départ pour démarrer le timer
                intervals: //  des intervals retournés par SetInterval (On lé créé ici pour pouvoir les supprimer via clerInterval()
                    {
                        timerUpdate: null,
                    },
                timeRecordMetrics: null, // contient la réponse de getTimeRecordsMetrics() Permet notamment de faire démarrer le timer avec le temps total travaillé aujourd'ui.

            }
        },
        computed:{

            // computed props for store :
            ...mapState({
                userSlug: state => state.user.slug,
                userTimezone: state => state.user.timezone,
                currentTimeRecord : state => state.currentTimeRecord,
                timerecords: state => state.MyRecentActivityComp.timerecords, //@todo récupérer le current depuis ici ?
            }),

            // un objet moment correspondant à maintenant
            datetimeNow: {
                // accesseur
                get: function () {
                    return this.now
                },
                // mutateur
                set: function (newValue) {
                    this.now = newValue
                }
            },

            // un objet moment correspondant à maintenant formaté ainsi '29 juin 2019'
            dateNow: {  get: function () {
                    return this.formatDateWithDayName(this.$moment(this.datetimeNow).tz(this.tzDetected), this.$route.params.locale)
                }
            },

            // un objet moment correspondant à maintenant formaté ainsi '15:56'
            timeNow: {  get: function () {
                    return this.$moment(this.datetimeNow).tz(this.tzDetected).format('LT')
                }
            }

        },
        methods: {

            toggleIsClockedIn() {
                if (this.isClockedIn === true) {
                    this.isClockedIn = false
                } else {
                    this.isClockedIn = true
                }

            },

            /**
             * ClockIn a timeRecord
             **/
            clockIn() {
                this.isSubmiting = true;
                let self = this;
                return self.$http
                    .post(`/organizations/${self.organizationSlug}/users/${self.userSlug}/clockin`,
                        {
                            timezone: this.tzDetected,
                            workspace: self.$auth.getActiveWorkspace()
                        },
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                      self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                      self.toggleIsClockedIn()

                        // on remplit les infos du currentTimeRecord
                        self.$store.commit('UpdateUserCurrentTimeRecord', response.data);
                        self.timerStart();

                        //on met à jour les timerecords dans le MyRecentActivityComp
                        self.timerecords.unshift(response.data)
                        self.$store.commit('UpdateMyRecentActivityComp', {
                            'timerecords' : self.timerecords
                        });

                        // tracking mixpanel
                        self.$mixpanel.track("clock in");
                        self.ga4GlobalEventTrack('User clocked in', {})

                        return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0009'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error on clock in', 'fatal': false})
                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error on clock in query"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error on clock in query : ${error}`, 'error')

                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            },

            /**
             * clockout a timeRecord
             **/
            clockOut() {
                this.isSubmiting = true;
                let self = this;
                return self.$http
                    .patch(`/organizations/${self.organizationSlug}/users/${self.userSlug}/clockout`,
                        {
                            timezone: this.currentTimeRecord.timezone,
                            workspace: this.$auth.getActiveWorkspace()
                        },
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                        self.timerStop();
                        self.toggleIsClockedIn()

                        // on supprime le currentTimeRecord du store
                        self.$store.commit('UpdateUserCurrentTimeRecord', null);

                        //on met à jour  la 1ère ligne tu tableau timerecords dans le MyRecentActivityComp
                        self.timerecords.splice(0,1,response.data)
                        self.$store.commit('UpdateMyRecentActivityComp', {
                            'timerecords' : self.timerecords
                        });

                        // tracking mixpanel
                        self.$mixpanel.track("clock out", {"duration":response.data.duration});
                        self.ga4GlobalEventTrack('User clocked out' , {})

                      return {}
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if(self.shouldBeIntercepted(error.response,self.$auth) === false){
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0010'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error on clock out', 'fatal': false})
                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error on clock out query"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error on clock out query : ${error}`, 'error')
                        }
                    })
                    .then(function () {
                        self.isSubmiting = false;
                    })
            },


            /**
             * Récupère le dernier TimeRecord
             * Permet de savoir si l'utilisateur est actuellement isClockedIn, de éventuellement mettre à jour le current TimeRecord dans le store et d'indiquer que le composant est prêt.
             **/
            getLastTimeRecord(){

                let self = this;
                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/users/${self.$auth.getUserSlug()}/timeRecords`,
                    {
                        // on ne récupère que le dernier tr non task
                        params: {limit : 1, sort :'desc', type:"excludeTask", workspace : self.$auth.getActiveWorkspace()},
                        headers: {Authorization: self.$auth.header()}
                    }
                )
                    .then(function (response) {
                        if(response.data[0] != undefined){ // si le dernier TimeRecord existe
                          self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur

                            if (response.data[0].timeOut == null) {
                                // l'utilisateur est clocked in...
                                self.$store.commit('UpdateUserCurrentTimeRecord', response.data[0]);
                                self.isClockedIn = true
                            } else {
                                // l'utilisateur est clocked out...
                                self.isClockedIn = false

                            }

                        }
                        self.componentIsReady = true;
                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0011'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching last timerecord', 'fatal': false})
                            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error fetching last timerecord"})

                            self.$sentry.captureMessage(`Error ${errorCode} > error fetching last timerecord in PointeuseComp : ${error}`, 'error')

                        }
                    })

            },

            /**
             * Get the TimeRecord Metrics
             * (Timerecords total duration by periods)
             **/
            getTimeRecordsMetrics(){

                let self = this;
                self.$http.get(
                    `organizations/${self.$auth.getOrganization()}/users/${self.$auth.getUserSlug()}/timeRecordsMetrics`,
                    {
                        // on ne récupère que le timerecords metrics non task
                        params: {type:"excludeTask"} ,
                        headers: {Authorization: self.$auth.header()}
                    }
                )
                    .then(function (response) {
                        self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
                        self.timeRecordMetrics = response.data;
                        self.timerStartValues =
                            {
                                seconds: response.data.totalToday.s,
                                minutes: response.data.totalToday.i,
                                hours : response.data.totalToday.h,
                            }

                            // initialisation du timer
                        self.initTimer()

                        // déclenchement du timer si en cours
                        if (self.isClockedIn === true){
                            self.timerStart();
                        }

                    })
                    .catch(function (error) {
                        // On catch ici sauf ce qui relève des intercepteurs Axios
                        if (self.shouldBeIntercepted(error.response, self.$auth) === false) {
                            self.logToSentry(self, error, 'error')
                            let errorCode = '0012'
                            self.showGlobalErrorNotif(self,errorCode)
                            self.$gtag.exception({'description': 'error '+errorCode + ' | error fetching timerecords metrics', 'fatal': false})
                          self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error fetching timerecords metrics"})
                            self.$sentry.captureMessage(`Error ${errorCode} > error fetching timerecords metrics : ${error}`, 'error')
                        }
                    })
                    .then(function () {
                    })
            },

            /**
             * Calcule un datetime correspondant à maintenant
             * @returns {string}
             */
            calculateDatetimeNow() {

                let moment = this.$moment().locale(this.$route.params.locale);
                this.datetimeNow =  moment

                return this.datetimeNow

            },

            /**
             * Créé l'objet timer via easyTimer
             * **/
            initTimer(){
                // require 'easy'
                var { Timer }  = require('easytimer.js');
                var timer = new Timer();

                let value = this.timerStartValues.hours + 'h ' +
                    this.prefixWithZero(this.timerStartValues.minutes) +'m ' +
                    this.prefixWithZero(this.timerStartValues.seconds) +'s' ;

                this.timerDisplayValue = value;
                this.timer = timer;
            },

            /**
             * Préfixe number avec un zéro si number est inférieur à neuf.
             * (4 -> 04)
             * @param number int
             * @returns int
             **/
            prefixWithZero(number){

                if(parseInt(number) <= 9){
                    return  '0'+number
                }
                else{
                    return  number
                }

            },

            /**
             * Formate la valeur du timer pour remplacer les ":" par des unités de valeurs 'h','m','s'
             * 12:23:11 -> 12h 23m 11s
             **/
            formatTimerDurationDisplay(timer, locale) {

                let val = timer.getTimeValues();
                let h = timer.getTotalTimeValues().hours
                let m = this.prefixWithZero(val.minutes)
                let s = this.prefixWithZero(val.seconds)

                switch (locale) {
                    case  'fr': // 05h 18m 37s
                        return `${h}h ${m}m ${s}s`;

                    case 'en': // 05h 18m 37s
                    default:
                        return `${h}h ${m}m ${s}s`;
                }
            },



            /**
             * Démarre le timer
             */
            timerStart(){
                // ajout des valeurs de départ
                this.timer.start({precision: 'seconds', startValues:this.timerStartValues,});
                clearInterval(this.intervals.timerUpdate); // on nettoie l'interval pour éviter une accumulation des déclenchements
                this.intervals.timerUpdate =  setInterval(this.updateTimerDisplay, 1000);
            },

            /**
             * stoppe le timer
             */
            timerStop(){
                this.timer.pause()
            },

            /**
             * Met à jour la valeur affichée du timer
             */
            updateTimerDisplay(){
                this.timerDisplayValue = this.getTimerValue();
            },

            /**
             * Retourne la valeur du timer
             */
            getTimerValue(){
                return this.formatTimerDurationDisplay(this.timer, this.$route.params.locale);
            },

        },
        mounted: function () {

            // On calcule un premier datetime puis on l'actualise chaque seconde
            setInterval(this.calculateDatetimeNow, 1000);

            clearInterval(this.intervals.timerUpdate); // on nettoie l'interval pour éviter une accumulation des déclenchements

            this.getLastTimeRecord();

            // récupération timerecords metrics
            this.getTimeRecordsMetrics();

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";


    .pointeuse{



            .blocPointeuse{

                background-image: url("../assets/img/stopwatchBg.png");
                background-position: center ;
                background-repeat: no-repeat;
                color: $brandFourth;
                padding: 2rem;
                /*position: relative;*/

                .icon {
                    top: 0;
                    left: 0;

                }

                .now{
                    margin-bottom: 7rem;
                    .time{
                        font-weight: bold;
                        font-style: italic;
                    }
                    /*.userTz{ color: #ccc;*/
                    /*    display: block;*/
                    /*    font-size:0.85rem;*/
                    /*}*/
                }

                .dailyTimer{
                    color :$brandFourth;
                    transition: color 0.3s;
                    font-size: 1.7rem;
                    font-weight: bold;
                    margin-bottom: 1rem;

                    &.running {

                        color: $brandThird;

                    }
                }

                .btnClockIn {

                    text-transform: lowercase;
                    padding: 1.8rem;

                    /*font-size: 1.1rem;*/
                    border: solid 1px transparent;
                    color: white;
                    .icon{
                        height: 0.9rem;
                        margin-right: -3px;
                    }

                }

                #btnClockOut{
                    $color: $brandRed;
                    background: $color;

                    &:hover {
                        transition: background-color 0.3s;
                        background: lighten($color, 5%);
                        color: white;
                    }

                    &:active {
                        background: darken($color, 5%);
                        transition: background-color 0.1s;
                        color: white;
                    }

                }

                #btnClockIn{
                    $color: $brandPrimary;
                    background: $color;

                    &:hover {
                        transition: background-color 0.3s;
                        background: lighten($color, 8%);
                        color: white;
                    }

                    &:active {
                        background: darken($color, 10%);
                        transition: background-color 0.1s;
                        color: white;
                    }

                }


            }

    }
</style>
